import ViewEditionModal from './viewEditionModal.view';

export default ViewEditionModal;
